import resume from '../assets/pdf/resume.pdf'
import profile from '../assets/jpg/profile4.JPG'

export const headerData = {
    name: 'Lisa (Ilshin) Ji',
    title: "Full Stack Software Developer",
    desciption:"I believe programming ability gives a new perspective to life problem-solving.",
    image: profile,
    resumePdf: resume
}
